B2cApp.config(['$httpProvider', ($httpProvider)->
  $httpProvider.defaults.headers.common['X-CSRF-Token'] = document.getElementsByName('csrf-token')[0].content
  $httpProvider.defaults.headers.common['Accept'] = 'application/json'
])

B2cApp.controller 'ProductController', ['$scope', '$timeout', '$http', ($scope, $timeout, $http) ->
  
  $scope.init = (product_type, social_network_id) ->
    $scope.product_type = product_type
    $scope.social_network_id = social_network_id
    $scope.product_selected = "tirage_10_10"
    
    
    $scope.products_height = (window.innerHeight - 105) / 3
    $scope.product_height = (window.innerHeight - 290) / 2#$scope.products_height - 60
    $scope.product_height = (window.innerWidth - 200) / 4#$scope.products_height - 60
    $scope.mokup_height = (window.innerHeight - 380)
    $scope.margin_top_step_1 = (window.innerHeight - $scope.product_height - 260) / 2
    
    $scope.modal_create_yearbook = new bootstrap.Modal(document.getElementById('create_yearbookv2'), {})
    $scope.modal_create_yearbook.show()
  
  $scope.change_product_type = (product_type) ->
    $scope.product_type = product_type
  
  $scope.select_product = (product) ->
    $scope.product_selected = product
    
  $scope.go_to_editeurV2 = () ->
    $scope.load_yearbook = true
    $.post("/startProductV2?product="+$scope.product_selected+"&social_network_id="+$scope.social_network_id)
      .then (response) ->
        window.location = "/social_networks/"+response.social_network_id+"/products?product_id=" + response.product_id
]
